module.exports = __webpack_public_path__ + "static/media/4.50b1a3f0.jpg";